import React, { Component } from 'react';
import { firestore } from '../../../firebase-config';
import Cabecalho from '../../../componentes/Cabecalho';
import CabecalhoPainel from '../../../componentes/CabecalhoPainel';
import { Redirect } from 'react-router-dom';
import { ValidatorForm, TextValidator, SelectValidator} from 'react-material-ui-form-validator';
import MenuItem from "@material-ui/core/MenuItem";
import * as firebase from "firebase/app";
import '../../custom_form.css';
import { base_url, api_key } from '../../../config/config_api';

class RevendaIntegracaoOfertaAutos extends Component {

    constructor (props){
        super(props);

        this.state = {
            returnPagina: false,
            estaGravando: false,
            idRevenda: props.match.params.idRevenda,
            descricao: "",
            nome_revenda: "",
            dados_revenda: null,
            veiculos: [],
            status: 0,
            existeConfiguracao: false,
            dataAtual: null,
            usuarioLogado: JSON.parse(window.localStorage.getItem("usuarioLogado")),
        }
        this.mounted = false;
        this.handleChange      = this.handleChange.bind(this);
        this.handleSubmit      = this.handleSubmit.bind(this);
        this.handleSincronizar = this.handleSincronizar.bind(this);

    }

    componentDidMount(){

        this.mounted = true;

        // firestore.settings({ timestampsInSnapshots: true });
        firestore.collection("revenda").doc(this.state.idRevenda)
        .get()
        .then(doc => {
            if (doc.exists) {
                this.setState({
                    nome_revenda: doc.data().penome_fantasia,
                    dados_revenda: doc.data()
                });
            }
        }).catch(function(error) {
        });

        firestore.collection("revenda").doc(this.state.idRevenda).collection("integracoes").doc("ofertaautos")
        .get()
        .then(doc => {
            if (doc.exists) {
                this.setState({
                    descricao: doc.data().descricao,
                    status: doc.data().status ? 1 : 0,
                    existeConfiguracao: true
                });                
            }
        }).catch(function(error) {
        });
        this.state.dataAtual = firebase.firestore.FieldValue.serverTimestamp();

    }

    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {

        this.setState({estaGravando: true});

        var user = JSON.parse(window.localStorage.getItem("usuarioLogado"));

        var integracao = {
            descricao: "OfertaAutos",
            status: parseInt(this.state.status) === 1 ? true : false,
            updated_id: user.id,
            updated_at: this.state.dataAtual
        }

        if(!this.state.existeConfiguracao) {
            integracao.created_id = user.id;
            integracao.created_at = this.state.dataAtual;
        }

        firestore.collection("revenda").doc(this.state.idRevenda).collection("integracoes").doc("ofertaautos").set(integracao, { merge: true })
        .then(res => { 

            fetch(base_url+"/api/integracao/ofertaautos/configurar", { 
                method: "POST", 
                headers: { 
                    'Content-Type': 'application/json',
                }, 
                body: JSON.stringify({
                    "api_key": api_key,
                    "id_revenda": this.state.idRevenda,
                    "usuario": user.id,
                    "status": parseInt(this.state.status) === 1 ? true : false,
                    "razao_social": this.state.dados_revenda.perazao_social_nome,
                    "nome_fantasia": this.state.dados_revenda.penome_fantasia,
                    "cpf_cnpj": this.state.dados_revenda.pecpf_cnpj,
                    "inscricao_estadual": this.state.dados_revenda.peinscricaoestadual,
                    "cep": this.state.dados_revenda.pecep_fiscal,
                    "logradouro": this.state.dados_revenda.peendereco_fiscal,
                    "numero": this.state.dados_revenda.peendereco_fiscal_numero,
                    "complemento": this.state.dados_revenda.peendereco_fiscal_compl,
                    "bairro": this.state.dados_revenda.pebairro_fiscal,
                    "cidade": this.state.dados_revenda.pecidade,
                    "uf": this.state.dados_revenda.peuf,
                    "blocotexto": this.state.dados_revenda.peblocotexto,
                    "email": this.state.dados_revenda.peemail,
                    "telefone1": this.state.dados_revenda.petelefone1,
                    "telefone2": this.state.dados_revenda.petelefone2,
                    "telefone3": this.state.dados_revenda.petelefone3,
                    "site": this.state.dados_revenda.pehomepage,
                    "facebook": this.state.dados_revenda.facebook_link,
                    "instagram": this.state.dados_revenda.instagram_link,
                })
            })
            .then(response => {
    
                response.json()
                .then(data => {

                    if(data.status === 'success'){
                        alert(data.data);
                    }else{
                        firestore.collection("revenda").doc(this.state.idRevenda).collection("integracoes").doc("ofertaautos").set({ status: false }, { merge: true });
                        alert(JSON.stringify(data.data));
                        // alert(data.data);
                    }
                    this.setState({returnPagina: true, estaGravando: false});
                });
                this.setState({estaGravando: false});  
    
            })
            .catch(error => {
                this.setState({estaGravando: false});  
                console.error("Erro get teste", error);
            });

        })
        .catch(err => { 

            firestore.collection("revenda").doc(this.state.idRevenda).collection("integracoes").doc("ofertaautos").set({ status: false }, { merge: true });

            alert("Erro ao configurar integração.")

            this.setState({estaGravando: false});     
        });

        event.preventDefault();

    }

    handleSincronizar(event) {

        this.setState({estaGravando: true});

        var user = JSON.parse(window.localStorage.getItem("usuarioLogado"));        

        // Verificar se a integração está ativa
        if(parseInt(this.state.status) == 1){

            firestore.collection("revenda").doc(this.state.idRevenda).collection("veiculos").where("veremovido", "==", 0).orderBy("vevendido").orderBy("updated_at", "desc")
            .get()
            .then(querySnapshot => {
                var items = [];
                querySnapshot.forEach(doc => {
                    var veiculo = {
                        "id_firebase": doc.id,
                        "marca": doc.data().vefipe_marca,
                        "modelo": doc.data().vefipe_name,
                        "ano_fabricacao": doc.data().veano_fabricacao,
                        "ano_modelo": doc.data().vefipe_ano_modelo,
                        "cor": doc.data().vecor,
                        "cambio": doc.data().vecambio,
                        "combustivel": doc.data().vefipe_combustivel.toLowerCase(),
                        "placa": doc.data().veiplaca,
                        "observacao": doc.data().veobservacao,
                        "portas": doc.data().veportas,
                        "km": doc.data().vequilometragem,
                        "tipoveiculo": doc.data().vetipoveiculo,
                        "carroceria": doc.data().vecarroceria,
                        "exibir": true,
                        "destaque": false,
                        "ordenacao": 0, // TODO: Implementar ordenação
                        "veiculonovo": (doc.data().veveiculonovo === 1 ? true : false),
                        "blindado": doc.data().veblindado,
                        "garantia_fabrica": doc.data().vegarantia_fabrica,
                        "ipva_pago": doc.data().veipva_pago,
                        "valor": parseFloat(doc.data().vevalor),
                        "opcionais": Object.keys(doc.data().opcionais).map(key => {
                            return doc.data().opcionais[key].id;
                        }),
                        "imagens": doc.data().imagens.map((imagem, index) => {
                            return {
                                "url": imagem.fileUrl,
                                "url_thumb": imagem.fileThumb,
                                "ordenacao": index,
                                "nome": imagem.fileName
                            };
                        })
                    };
                    items.push(veiculo);
                });
                if(this.mounted) {
                    this.setState({
                        veiculos: items,
                    });
                }                    

                fetch(base_url+"/api/integracao/ofertaautos/sincronizar", { 
                    method: "POST", 
                    headers: { 
                        'Content-Type': 'application/json',
                    }, 
                    body: JSON.stringify({
                        "api_key": api_key,
                        "id_revenda_firebase": this.state.idRevenda,
                        "usuario": user.id,
                        "veiculos": this.state.veiculos
                    })
                })
                .then(response => {
        
                    response.json()
                    .then(data => {
                        if(data.status === 'success'){

                            data.data.forEach(doc => {
                                var integracao = {
                                    status: true,
                                    id_anuncio: doc,
                                    url_anuncio: "https://ofertaautos.com.br/veiculo/"+doc,
                                };
                                console.log("Integrando veículo: " + doc);
                                firestore.collection('revenda').doc(this.state.idRevenda).collection('veiculos').doc(doc).collection('integracoes').doc("ofertaautos").set(integracao, { merge: true });
                            });

                            alert("Sincronização realizada com sucesso!");
                            this.setState({estaGravando: false});
                            
                        }else{
                            alert(JSON.stringify(data.data));
                            this.setState({estaGravando: false}); 
                        }

                    });
        
                })
                .catch(error => {
                    console.log(error);
                    this.setState({estaGravando: false});  
                });

            });

        } 

        // this.setState({estaGravando: false});

        event.preventDefault();

    }

    render(){
        const { 
            estaGravando, 
            nome_revenda,
            status,
            idRevenda
        } = this.state;

        if(this.state.returnPagina){
            return <Redirect to={ "/revenda/"+idRevenda+"/integracao" } />;
        }

        if(this.state.usuarioLogado !== null && this.state.usuarioLogado.role !== 'admin'){
            return <Redirect to='/acesso-negado' />
        }
        
        return (

            <div>
                {
                    this.state.usuarioLogado !== null && this.state.usuarioLogado.role === 'admin' ? <Cabecalho /> :  <CabecalhoPainel />
                }
                <div id="page-wrapper">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1 className="page-header">Integração Oferta Autos<br/><small>Revenda: { nome_revenda }</small></h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    Configurar integração Oferta Autos
                                </div>
                                <div className="panel-body">

                                    <ValidatorForm
                                        ref="form"
                                        onSubmit={this.handleSubmit}
                                    >
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <SelectValidator
                                                        label="Status integração"
                                                        value={ status }
                                                        name="status"
                                                        className="form-ui-bootstrap"
                                                        onChange={this.handleChange}
                                                        validators={["required"]}
                                                        errorMessages={["Preenchimento obrigatório"]}
                                                        >
                                                            <MenuItem value="1">Ativo</MenuItem>
                                                            <MenuItem value="0">Inativo</MenuItem>                                                     
                                                    </SelectValidator>
                                                </div>
                                            </div>
                                        </div>                                                                             
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div style={{ display: estaGravando ? " block " : " none "  }}><img src="/img/aguarde.gif" alt="carregando"  style={{ height: '80px', marginBottom: '10px'}} /></div>
                                                <a href={ "/revenda/"+idRevenda+"/integracao"} className="btn btn-warning" >Voltar</a> <button type="submit" className="btn btn-primary" disabled={estaGravando} >Gravar</button> <button type="button" onClick={this.handleSincronizar} className="btn btn-success" disabled={estaGravando} >Sincronizar Estoque</button>
                                            </div>
                                        </div>
                                    </ValidatorForm>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }

}

export default RevendaIntegracaoOfertaAutos
